import { radius } from '@alison/ui';
import Chip from '@mui/material/Chip';
import type { ReactNode } from 'react';

export function OverrideChip({ label }: { label: string }): ReactNode {
  return (
    <Chip
      size="small"
      variant="outlined"
      label={label}
      sx={{
        height: 22,
        borderRadius: `${radius.sm}px`,
        bgcolor: 'background.platform',
        borderColor: 'divider',
        color: 'text.secondary',
      }}
    />
  );
}
